import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SocialLearningPostGet } from 'src/app/_models';
import { BaseComponent } from 'src/app/_base/base.component';
import * as moment from 'moment';
import { TranslatePipe } from '@ngx-translate/core';
import { SocialLearningService } from 'src/app/_services';
@Component({
  selector: 'app-whatsapp-comments',
  templateUrl: './whatsapp-comments.component.html',
  styleUrls: ['./whatsapp-comments.component.scss'],
  providers: [TranslatePipe]
})
export class WhatsappCommentsComponent extends BaseComponent implements OnInit {
  @Input()
  comments: SocialLearningPostGet = {
    results: [],
    totalRecords: 0
  };
  @Output()
  commentsEmitter: EventEmitter<SocialLearningPostGet> = new EventEmitter<SocialLearningPostGet>();
  constructor(private translatePipe: TranslatePipe, private socialLearningService: SocialLearningService) {
    super();
  }

  ngOnInit() {}
  getUserImage(userImage: string): string {
    return userImage !== null && this.getImage(userImage) ? this.getImage(userImage) : './assets/Images/users/default-user.jpg';
  }
  getDateTime(createdOn: string): string {
    return moment(createdOn)
      .locale(this.translateService.currentLang)
      .calendar(null, {
        sameDay: `[${this.translatePipe.transform('Common.Today')}] hh:mm A`,
        lastDay: `[${this.translatePipe.transform('Common.Yesterday')}] hh:mm A`,
        lastWeek: this.getFormat(),
        sameElse: this.getFormat()
      });
  }
  getFormat(): string {
    return this.settings.rtl ? 'hh:mm A DD/MM/YYYY' : 'YYYY/MM/DD hh:mm A';
  }
  postCommentDelete(commentId: number): void {
    const callback = () => {
      this.socialLearningService.DeleteComment(commentId).subscribe(() => {
        const postCommentIndex = this.comments.results.findIndex(item => item.postItemId === commentId);
        if (postCommentIndex !== -1) this.comments.results.splice(postCommentIndex, 1);
        this.comments.totalRecords -= 1;
        this.commentsEmitter.emit(this.comments);
      });
    };
    this.showConfirmYesNoMessage('Common.AreYouSureYouWantToDeleteThisComment?', 'Common.DeleteComment', callback);
  }
}
